import React, { Component, createRef } from "react"
import { connect } from "react-redux"
import toastr from "toastr"
import { editLineUserBill } from "../../actions/lineUserActions"
import Modal from "../../components/modals/Modal"

class MonthlyBillUpdate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lineUser: props.lineUserToAddOrEdit || {},
      sendSms: false,
      billChangeNote: "",
      newMonthlyBill: 0,
      mobile: "",
    }
    this.newMonthlyBillRef = createRef()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { requestPending, errorMsg } = nextProps.server
    if (requestPending || errorMsg) return

    let mobile
    if (nextProps.lineUserToAddOrEdit.mobile && nextProps.lineUserToAddOrEdit.mobile !== "01700000000") {
      mobile = nextProps.lineUserToAddOrEdit.mobile
    }

    this.setState({
      lineUser: nextProps.lineUserToAddOrEdit,
      modalTitle: nextProps.modalTitle,
      newMonthlyBill: nextProps.lineUserToAddOrEdit.monthlyBill,
      mobile,
      billChangeNote: "",
    })
  }

  onChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleCheckBoxClick() {
    this.setState({ sendSms: !this.state.sendSms })
  }

  onSubmitHandler = (e) => {
    e.preventDefault()
    let { id, name, monthlyBill } = this.state.lineUser
    let { sendSms, billChangeNote, newMonthlyBill, mobile } = this.state
    let msg

    if (!newMonthlyBill) {
      toastr.error("মাসিক ফি পুরন করুন")
      this.newMonthlyBillRef.current.focus()
      return
    } else if (newMonthlyBill) {
      let isNum = /^\d+$/.test(newMonthlyBill)
      if (!isNum) {
        toastr.error("মাসিক ফি সঠিক নয়")
        this.newMonthlyBillRef.current.focus()
        return
      }

      if (newMonthlyBill > 100000) {
        toastr.error("মাসিক ফি সঠিক নয়। সর্বোচ্চঃ 100000")
        this.newMonthlyBillRef.current.focus()
        return
      }
    }

    if (newMonthlyBill < monthlyBill) {
      msg = `আপনি যদি ${name} এর মাসিক ফি ${monthlyBill - newMonthlyBill} টাকা কমাতে চান, তাহলে OK বাটনে ক্লিক করুন।`
    } else if (newMonthlyBill > monthlyBill) {
      msg = `আপনি যদি ${name} এর মাসিক ফি ${newMonthlyBill -
        monthlyBill} টাকা বৃদ্ধি করতে চান, তাহলে OK বাটনে ক্লিক করুন।`
    } else {
      toastr.error("পূর্বের মাসিক ফি এবং পরিবর্তিত মাসিক ফি সমান")
      this.newMonthlyBillRef.current.focus()
      return
    }

    let con = window.confirm(msg)
    if (con) {
      const data = {
        type: "BILL",
        sendSms: sendSms ? "yes" : "no",
        newMonthlyBill: newMonthlyBill,
        billChangeNote: billChangeNote,
        id,
      }
      this.props.editLineUserBill(data)
    }
  }

  render() {
    const { lineUser, newMonthlyBill, sendSms, billChangeNote, mobile } = this.state
    return (
      <>
        <Modal
          modalTitle="মাসিক ফি আপডেট"
          onSubmit={this.onSubmitHandler}
          pending={this.props.server.requestPending}
          id="monthlyBillUpdate"
          modalWidth="w-50"
        >
          <div className="row">
            <div className="col-md-6 text-left mb-1">
              আইডিঃ <strong>{lineUser.customerID}</strong>
            </div>
            <div className="col-md-6 text-left mb-1">
              মাসিক ফিঃ <strong>{lineUser.monthlyBill} টাকা</strong>
            </div>

            <div className="col-md-6 text-left mb-1">
              গ্রাহকঃ <strong>{lineUser.name}</strong>
            </div>
            <div className="col-md-6 text-left mb-2">
              বিলঃ <strong>{lineUser.dueAmount} টাকা</strong>
            </div>
            {<div className="col-md-6 text-left mb-2">মোবাইলঃ {mobile ? <strong>{mobile}</strong> : "নাই"}</div>}
            <div className="col-md-6"></div>

            {/* New Monthly Bill  */}
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="newMonthlyBill">নতুন মাসিক ফি</label>
                <input
                  ref={this.newMonthlyBillRef}
                  className="form-control"
                  onChange={this.onChangeHandler}
                  value={newMonthlyBill}
                  type="number"
                  name="newMonthlyBill"
                />
              </div>
            </div>

            {/* নোট  */}
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="billChangeNote">নোট</label>
                <input
                  ref={this.billChangeNoteRef}
                  className="form-control"
                  onChange={this.onChangeHandler}
                  value={billChangeNote}
                  type="text"
                  name="billChangeNote"
                />
              </div>
            </div>

            {mobile && <div className="col-md-6"></div>}
            {mobile && (
              <div className="col-md-6 text-right">
                <div className="form-group">
                  <input
                    // className="form-control"
                    type="checkbox"
                    name="sendSms"
                    checked={sendSms}
                    onClick={this.handleCheckBoxClick.bind(this)}
                    disabled={!mobile}
                  />
                  &nbsp; গ্রাহকের মোবাইলে মেসেজ যাবে
                </div>
              </div>
            )}
          </div>
          {/*END OF ROW */}
        </Modal>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    feederID: state.auth.user.profile.profileID,
    profile: state.profile,
    lineUser: state.lineUser,
    server: state.server,
  }
}

export default connect(mapStateToProps, { editLineUserBill })(MonthlyBillUpdate)
